import { render, staticRenderFns } from "./CenaculoMisericordia.vue?vue&type=template&id=04df208f&scoped=true"
import script from "./CenaculoMisericordia.vue?vue&type=script&lang=js"
export * from "./CenaculoMisericordia.vue?vue&type=script&lang=js"
import style0 from "./CenaculoMisericordia.vue?vue&type=style&index=0&id=04df208f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df208f",
  null
  
)

export default component.exports